/**
 * Copyright © 2026 Adnuntius AS.
 */
import {AdnExecutionResource} from './execution-resource.resource';

/** Angular DI token for the DiagnosticRequestExecution HTTP resource (factory product). */
export class DiagnosticRequestExecutionResource {
}

export function createDiagnosticRequestExecutionResource(adnExecutionResource: any): any {
  const DiagnosticRequestExecution = adnExecutionResource('diagnosticrequests');
  DiagnosticRequestExecution.start = function(params: any): Promise<any> {
    return DiagnosticRequestExecution.$start(params);
  };
  return DiagnosticRequestExecution;
}

export const diagnosticRequestExecutionResourceProvider = {
  provide: DiagnosticRequestExecutionResource,
  useFactory: createDiagnosticRequestExecutionResource,
  deps: [AdnExecutionResource]
};

